export const GenericAPIHandler = {
  methods: {
    showErrorDialog (error) {
      const errorMessage = error.response.data.msg || error.response.data.error
      this.$alert(`อุ๊ปส์! ${errorMessage}`, 'ผิดพลาด', {
        confirmButtonText: 'โอเค',
        type: 'error',
      })
    },
    showSuccessDialog (router) {
      this.$alert('เย่ บันทึกข้อมูลเรียบร้อย', '', {
        showConfirmButton: false,
        closeOnHashChange: true,
        callback: () => {
          this.$router.push(router)
        },
        type: 'success',
      })
      let interval = setTimeout(() => {
        location.hash = 'confirm'
        clearTimeout(interval)
        this.$router.push(router)
      }, 1000)
    },
    async showCancelDialog (router) {
      try {
        await this.$confirm('คุณต้องการยกเลิกการลงข้อมูล ?', {
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ไม่',
          type: 'warning',
          showClose: false,
        })
        this.$router.push(router)
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
  },
}
